import LandingPage from './components/landing-page';
import Navigation from './partials/navigation';

let isLandingPage = false;
let isLandingMobile = false;

if ( document.body.classList.contains('single-landingpage') ) {
    if ( window.innerWidth >= 992 ) {
        isLandingPage = true;
        let {slides, lock} = LandingPage();
    } else {
        isLandingMobile = true;
    }
}

if (isLandingPage) {
    window.addEventListener('load', () => {
        console.log('LOADED DESKTOP');
        setTimeout(() => {
            window.scrollTo(0, 0);
            lock.start();
        }, 1000);
    });
}
if (isLandingMobile) {
    window.addEventListener('load', () => {
        console.log('LOADED MOBILE');
    });
}

;(function() {

    jQuery(document).ready(function($) {
        if (isLandingPage) {

            $('.arrow[data-next]').click((e) => {
                e.preventDefault();
                slides.pause();
                lock.start().go(lock.$state.index + 1);
            });

            $('.arrow[data-next-article]').click((e) => {
                slides.next();
            });

            $('a.top').click((e) => {
                e.preventDefault()
                slides.pause();
                lock.resetShift();
                lock.start().go(0);

                setTimeout(() => {
                    slides.reset();
                }, lock.options.wait);
            });
        }

        if ( isLandingMobile ) {
            $('.arrow').on('click touch', function(e) {
                e.preventDefault();

                $('html, body').animate({ scrollTop : $('.landingpage__slide:first').offset().top }, 200);

                return false;
            });
        }

        Navigation($);

		// Hamburger animation
		$('.js-hamburger-toggle').on('click', function() {
			$('.js-hamburger-toggle').toggleClass('is-active');

			($('.js-hamburger-toggle .item__title').text() == 'Menu') ? $('.js-hamburger-toggle .item__title').text('Luk') : $('.js-hamburger-toggle .item__title').text('Menu');

			$('body, html').toggleClass('js-nav-open');
			return false;
		});

		// Mobile Subnavigation
		$('.navigation--offset li.navigation--offset__sub').click(function() {
		  var submenu = $(this).children('.navigation__sub');
		  submenu.toggleClass('is-active');
		});

		// Overlay
		var bh = $('body, html');
		$('.content-overlay').on('click', function() {
			bh.hasClass('js-nav-open') && (bh.removeClass('js-nav-open'), $('.js-hamburger-toggle').removeClass('is-active'), $('.js-hamburger-toggle .item__title').text() == 'Menu') ? $('.js-hamburger-toggle .item__title').text('Luk') : $('.js-hamburger-toggle .item__title').text('Menu');
		});

		// Gallery
		var $grid = $('.cases:not(.cases--alm) .cases__gallery').imagesLoaded( function() {
			// init Masonry after all images have loaded
			$grid.masonry({
				gutter: 10,
  				itemSelector: '.grid-item'
			});

            $('.grid-item img').each(function() {
                if ( !$(this).data('height') ) {
                    return;
                }

                var $parent = $(this).parent(),
                    $height = $(this).data('height');

                var newHeight = $parent.width() / 450 * $height;

                $(this).css('height', newHeight + "px");
            });

            $('.grid-item img').addClass('not-loaded');
            $('.grid-item img.not-loaded').lazyload({
                effect: 'fadeIn',
                load: function() {
                    // Disable trigger on this image
                    $(this).removeClass("not-loaded");
                    $grid.masonry('layout');
                }
            });
            $('.grid-item img.not-loaded').trigger('scroll');
		});

		// Gallery with Ajax load functionality
		var masonryInit = true; // set Masonry init flag
	  	$.fn.almComplete = function(alm){ // Ajax Load More callback function
			if ( $('.cases--alm').length ) {
		  		var $container = $('.cases .cases__gallery'); // our container
		  		if ( masonryInit ) {
					// initialize Masonry only once
					masonryInit = false;
					$container.masonry({
			  			gutter: 10,
			  			itemSelector: '.grid-item'
					});
		  		} else {
			  		$container.masonry('reloadItems'); // Reload masonry items after callback
		  		}

                $('.grid-item img').each(function() {
                    if ( !$(this).data('height') ) {
                        return;
                    }

                    var $parent = $(this).parent(),
                        $height = $(this).data('height');

                    var newHeight = $parent.width() / 450 * $height;

                    $(this).css('height', newHeight + "px");
                });

                $('.grid-item img').addClass('not-loaded');
                $('.grid-item img.not-loaded').lazyload({
                    effect: 'fadeIn',
                    load: function() {
                        // Disable trigger on this image
                        $(this).removeClass("not-loaded");
                        $container.masonry('layout');
                    }
                });
                $('.grid-item img.not-loaded').trigger('scroll');

		  		$container.imagesLoaded( function() { // When images are loaded, fire masonry again.
					$container.masonry();
		  		});
                setTimeout(function() {
                    if ( window.pageYOffset === 0 ) {
                        return;
                    }
                    $('html, body').scrollTop( window.pageYOffset + 20 );
                }, 500);
			}
	  	};

        $( window ).resize(function() {
            console.log('resize');
            $('.cases .grid-item img').each(function() {
                if ( !$(this).data('height') ) {
                    return;
                }

                var $parent = $(this).parent(),
                    $height = $(this).data('height');

                var newHeight = $parent.width() / 450 * $height;

                $(this).css('height', newHeight + "px");
            });
        });

		// Lightbox in gallery
		$('.cases__gallery').magnificPopup({
			delegate: 'a',
	  		type: 'image',
	  		closeOnContentClick: true,
	  		closeBtnInside: false,
	  		fixedContentPos: true,
	  		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
	  		image: {
	  			verticalFit: true
	  		},
	  		zoom: {
	  			enabled: true,
	  			duration: 300 // don't foget to change the duration also in CSS
	  		}
	  	});

		// Lightbox on individual images (with class)
		$('.lightbox').magnificPopup({
			type: 'image',
			closeOnContentClick: true,
			closeBtnInside: false,
			fixedContentPos: true,
			mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
			image: {
				verticalFit: true
			},
			zoom: {
				enabled: true,
				duration: 300 // don't foget to change the duration also in CSS
			}
		});


		$('.newsletter-toggle').click(function(e) {
			e.preventDefault();
			$('.newsletter--top').toggleClass('newsletter--active');
			$('.newsletter-toggle').toggleClass('newsletter-active');
		});

		// FAQ
	    $('.accordion-trigger').on('click', function(e) {
	        e.preventDefault();
	        $(this).toggleClass('active');

	        var target = $(this).closest('.question').find('.answer').parent();
	        $(target).slideToggle(300);
	    });

		$('.fotorama').fotorama({
			autoplay: true,
			loop: true,
			nav: false,
			arrows: 'always',
			click: true,
			swipe: true,

			fit: 'cover',
			width: '100%',
			maxheight: '650px',

		});

	});
}());
